import React from 'react';
import { Shield, Heart, MapPin, Star } from 'lucide-react';

const stats = [
  { number: "500+", label: "Événements/an" },
  { number: "10 ans", label: "D'expérience" },
  { number: "98%", label: "Clients satisfaits" },
  { number: "300+", label: "Produits" }
];

const values = [
  { title: "Qualité", description: "Matériel professionnel régulièrement entretenu et contrôlé", icon: Shield },
  { title: "Service", description: "Équipe réactive et à l'écoute de vos besoins", icon: Heart },
  { title: "Proximité", description: "Présents sur toute la Normandie avec un service personnalisé", icon: MapPin }
];

const testimonials = [
  { id: 1, name: "Marie D.", location: "Le Havre", rating: 5, comment: "Service impeccable pour notre mariage à Étretat." },
  { id: 2, name: "Jean-Pierre L.", location: "Rouen", rating: 5, comment: "Excellent rapport qualité-prix pour notre événement." },
  { id: 3, name: "Sophie M.", location: "Honfleur", rating: 5, comment: "Très réactifs et à l'écoute de nos besoins." }
];

const AProposPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      {/* Header */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">À Propos de Nous</h1>
          <p className="text-xl text-orange-200 max-w-2xl mx-auto">
            Découvrez l'histoire et les valeurs de Barnum Événement
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Notre Histoire</h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6">
                Depuis 2015, Barnum Événement accompagne les particuliers et professionnels de Normandie dans l'organisation de leurs événements. Notre expertise et notre parc matériel de qualité nous permettent de répondre à toutes vos demandes.
              </p>
              <p className="text-lg text-gray-600 leading-relaxed">
                Notre mission est simple : vous accompagner dans la réussite de vos événements en vous proposant un matériel de qualité et un service irréprochable.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1511795409834-ef04bbd61622?w=600&h=500&fit=crop"
                alt="Notre équipe"
                className="rounded-2xl shadow-xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-orange-500 text-white p-6 rounded-xl shadow-lg">
                <div className="text-3xl font-bold">10 ans</div>
                <div className="text-orange-200">d'expérience</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-orange-500 mb-2">500+</div>
              <div className="text-gray-600">Événements/an</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-orange-500 mb-2">10 ans</div>
              <div className="text-gray-600">D'expérience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-orange-500 mb-2">98%</div>
              <div className="text-gray-600">Clients satisfaits</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-orange-500 mb-2">300+</div>
              <div className="text-gray-600">Produits</div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">Nos Valeurs</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gray-50 rounded-2xl">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Shield className="w-8 h-8 text-orange-500" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Qualité</h3>
              <p className="text-gray-600">Matériel professionnel régulièrement entretenu et contrôlé</p>
            </div>
            <div className="text-center p-8 bg-gray-50 rounded-2xl">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Heart className="w-8 h-8 text-orange-500" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Service</h3>
              <p className="text-gray-600">Équipe réactive et à l'écoute de vos besoins</p>
            </div>
            <div className="text-center p-8 bg-gray-50 rounded-2xl">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <MapPin className="w-8 h-8 text-orange-500" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Proximité</h3>
              <p className="text-gray-600">Présents sur toute la Normandie avec un service personnalisé</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-orange-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-white text-center mb-12">Ce que disent nos clients</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white/10 backdrop-blur rounded-2xl p-6">
              <div className="flex gap-1 mb-4">
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              </div>
              <p className="text-white/90 mb-4">"Service impeccable pour notre mariage à Étretat."</p>
              <div>
                <div className="font-semibold text-white">Marie D.</div>
                <div className="text-sm text-orange-300">Le Havre</div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur rounded-2xl p-6">
              <div className="flex gap-1 mb-4">
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              </div>
              <p className="text-white/90 mb-4">"Excellent rapport qualité-prix pour notre événement."</p>
              <div>
                <div className="font-semibold text-white">Jean-Pierre L.</div>
                <div className="text-sm text-orange-300">Rouen</div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur rounded-2xl p-6">
              <div className="flex gap-1 mb-4">
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
                <Star className="w-5 h-5 text-yellow-400 fill-yellow-400" />
              </div>
              <p className="text-white/90 mb-4">"Très réactifs et à l'écoute de nos besoins."</p>
              <div>
                <div className="font-semibold text-white">Sophie M.</div>
                <div className="text-sm text-orange-300">Honfleur</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AProposPage;
